import { DROPDOWN_STATUS } from '../enums/dropdown-status';

export const statusColor = {
    [DROPDOWN_STATUS.SUCCESS]: '#63C585',
    [DROPDOWN_STATUS.WARNING]: '#FEBA08',
    [DROPDOWN_STATUS.ERROR]: '#F25325',
};
